
import FileValidationMain from "components/Batch/FileValidationMain";
import MainLayout from 'layouts/mainLayout'

export default function FileValidationPage() {
    const fieldMappingRows = [
        {
            "fieldOrder": 1,
            "fieldName": "Client Internal ID",
            "required": false
        },
        {
            "fieldOrder": 2,
            "fieldName": "Internal Disposition",
            "required": false
        },
        {
            "fieldOrder": 3,
            "fieldName": "DBA",
            "required": false
        },
        {
            "fieldOrder": 4,
            "fieldName": "Company Legal Name",
            "required": true
        },
        {
            "fieldOrder": 5,
            "fieldName": "Street Address",
            "required": true
        },
        {
            "fieldOrder": 6,
            "fieldName": "Locality",
            "required": true
        },
        {
            "fieldOrder": 7,
            "fieldName": "Region",
            "required": false
        },
        {
            "fieldOrder": 8,
            "fieldName": "Postal Code",
            "required": true
        },
        {
            "fieldOrder": 9,
            "fieldName": "Country Code",
            "required": true
        },
        {
            "fieldOrder": 10,
            "fieldName": "Phone No.",
            "required": false
        },
        {
            "fieldOrder": 11,
            "fieldName": "Website",
            "required": false
        },
        {
            "fieldOrder": 12,
            "fieldName": "Tax ID",
            "required": false
        },
        {
            "fieldOrder": 13,
            "fieldName": "National ID",
            "required": false
        },
        {
            "fieldOrder": 14,
            "fieldName": "Full Name",
            "required": false
        }
    ]

    return (
        <MainLayout>
            <FileValidationMain
                loading={false}
                showFileName={false}
                disableFileUpload={false}
                fieldMappingRows={fieldMappingRows}
                mappedData={{
                    "rows": null,
                    "isError": false,
                    "msg": null
                }}
                fileName={null}
                hasHeaderRow={true}
                testMatchLoading={false}
                testMatchData={null}
                loadData={1}
                showAlert={false}
                showRunTestError={false}
                showFileAlert={false}
                mappedDataLoading={false}
                fileLoading={false}
                onFieldChange={() => { }}
                onUpdate={() => { }}
                onFileSelect={() => { }}
                onRemove={() => { }}
                onDownload={() => { }}
                onShowMappedData={() => { }}
                onHeaderRowChange={() => { }}
                onReset={() => { }}
                onClearAll={() => { }}
                onRunMatch={() => { }}
                onAlertClose={() => { }}
            />
        </MainLayout>
    );
}
